import styles from "./SliderHistory.module.scss";
import classNames from "classnames/bind";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Grid, Lazy, FreeMode } from "swiper";
import { Link } from "react-router-dom";
import React from "react";
import AllCar from "~/Data";
import { handleHistoryView } from "~/hooks/function";
const cx = classNames.bind(styles);
function SliderHistory() {
    console.log("SliderHistory");
    const historySave = JSON.parse(localStorage.getItem("history")) || AllCar;
    historySave.reverse();
    historySave.length > 12 && (historySave.length = 12);
    return (
        <div className={cx("history_wrap")}>
            <div className={cx("wrapper_swiper")}>
                <Swiper
                    slidesPerView={5}
                    lazy={true}
                    freeMode={true}
                    grid={{
                        rows: 1,
                    }}
                    pagination={{
                        dynamicBullets: true,
                    }}
                    modules={[Grid, Lazy, Pagination, FreeMode]}
                    breakpoints={{
                        "@0.00": {
                            slidesPerView: 2.6,
                            pagination: false,
                        },
                        1300: {
                            slidesPerView: 5,
                        },
                        1700: {
                            slidesPerView: 6,
                        },
                    }}
                    className={cx("swiper")}
                >
                    {" "}
                    {historySave.map((car, index) => (
                        <SwiperSlide key={index} className={cx("swiper_item")}>
                            <Link
                                onClick={() => handleHistoryView(car)}
                                className={cx("swiper_item-link")}
                                to={car.link}
                            >
                                <img
                                    className={cx("swiper-lazy")}
                                    loading="lazy"
                                    src={car.avatar}
                                    alt={car.name}
                                    // onClick={(e) => handleClick(car)}
                                />

                                <div>
                                    <h4>{car.name}</h4>
                                    <div className={cx("car_info")}>
                                        <p> {car.brand}</p>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default React.memo(SliderHistory);
